"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSection = void 0;
var react_1 = __importDefault(require("react"));
var Lockup_1 = __importDefault(require("../Lockup"));
var Grid_1 = __importDefault(require("../Grid"));
var VerticalSpacer_1 = __importDefault(require("../../utils/VerticalSpacer"));
var styles_1 = require("./styles");
var VS_1 = { small: 24, medium: 40, large: 60 };
var GRID_1_CELL_SPAN_1 = {
    small: 'full',
    medium: 'full',
    large: 'full',
};
var PageSection = function (_a) {
    var title = _a.title, _b = _a.titleMaxWidth, titleMaxWidth = _b === void 0 ? 16 : _b, subtitle = _a.subtitle, _c = _a.subtitleMaxWidth, subtitleMaxWidth = _c === void 0 ? 32 : _c, children = _a.children, footer = _a.footer, _d = _a.collapseTopPadding, collapseTopPadding = _d === void 0 ? false : _d, _e = _a.collapseBottomPadding, collapseBottomPadding = _e === void 0 ? false : _e, _f = _a.noTopPadding, noTopPadding = _f === void 0 ? false : _f, _g = _a.noBottomPadding, noBottomPadding = _g === void 0 ? false : _g, _h = _a.align, align = _h === void 0 ? 'center' : _h, _j = _a.headingLevel, headingLevel = _j === void 0 ? 1 : _j, _k = _a.backgroundColor, backgroundColor = _k === void 0 ? 'transparent' : _k, decorationName = _a.decorationName, decorationPosition = _a.decorationPosition, commonProps = __rest(_a, ["title", "titleMaxWidth", "subtitle", "subtitleMaxWidth", "children", "footer", "collapseTopPadding", "collapseBottomPadding", "noTopPadding", "noBottomPadding", "align", "headingLevel", "backgroundColor", "decorationName", "decorationPosition"]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "PageSection" }, commonProps, { "$collapseTopPadding": collapseTopPadding, "$collapseBottomPadding": collapseBottomPadding, "$noTopPadding": noTopPadding, "$noBottomPadding": noBottomPadding, "$backgroundColor": backgroundColor }),
        react_1.default.createElement(VerticalSpacer_1.default, { amount: VS_1 },
            title && (react_1.default.createElement(Grid_1.default, null,
                react_1.default.createElement(Grid_1.default.Cell, { span: GRID_1_CELL_SPAN_1 },
                    react_1.default.createElement(styles_1.Header, null,
                        react_1.default.createElement(Lockup_1.default, { title: title, subtitle: subtitle, subtitleMaxWidth: subtitleMaxWidth, align: align, level: "2", headingLevel: headingLevel, titleMaxWidth: titleMaxWidth }))))),
            children && react_1.default.createElement("div", null, children),
            footer && (react_1.default.createElement(Grid_1.default, null,
                react_1.default.createElement(Grid_1.default.Cell, { span: "full" },
                    react_1.default.createElement(styles_1.Footer, { "$hAlign": align }, footer))))),
        decorationName && decorationPosition && (react_1.default.createElement(styles_1.Decoration, { name: decorationName, "$position": decorationPosition, "$collapseTopPadding": collapseTopPadding, "$collapseBottomPadding": collapseBottomPadding }))));
};
exports.PageSection = PageSection;
exports.default = exports.PageSection;
